import { Box, Heading } from "grommet";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { getTopicArticlesServerSideProps } from "@backend/blog";
import Breadcrumb from "@components/breadcrumb";
import Layout from "@components/layout";
import Pagination from "@components/pagination";
import capitalFirst from "@helpers/capitalFirst";
import getPage from "@helpers/getPage";
import { pageSize } from "@organisms/article/helpers";
import List from "@organisms/article/list";

export default function Blog({ articles, totalArticles, topic }) {
  const router = useRouter();
  const page = getPage(router.query.page);

  const onPageChange = useCallback(
    (page) => {
      const q = [topic && `topic=${topic}`, page > 1 && `page=${page}`]
        .filter(Boolean)
        .join("&");

      router.push(`?${q}`, "", { scroll: false });
    },
    [topic]
  );

  const capitalizedTopic = capitalFirst(topic);

  return (
    <Layout seo={{ title: "Blog", description: "Coinscope's blog spot" }}>
      <Box width={{ width: "100%", max: "xlarge" }} alignSelf="center">
        <Breadcrumb
          links={[
            { label: "Blog", title: "go to Blog", href: "/blog" },
            { label: capitalizedTopic, title: capitalizedTopic },
          ]}
        />
        <Heading level="1" margin={{ vertical: "large" }}>
          {capitalizedTopic}
        </Heading>
        <List articles={articles} />
        {totalArticles > pageSize && (
          <Pagination
            page={page}
            onChange={onPageChange}
            step={pageSize}
            numberItems={totalArticles}
            margin={{ top: "medium" }}
          />
        )}
      </Box>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  return getTopicArticlesServerSideProps(context);
}
